var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsOcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_2583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_2583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19.275L2.025 10.35C1.94166 9.81667 2.07083 9.33333 2.4125 8.9C2.75416 8.46667 3.19166 8.20833 3.725 8.125L5.25 19L12.325 18H19C18.8667 18.35 18.6625 18.6458 18.3875 18.8875C18.1125 19.1292 17.775 19.275 17.375 19.325L5.45 20.975C4.9 21.0583 4.41666 20.9333 4 20.6C3.58333 20.2667 3.33333 19.825 3.25 19.275ZM8 16.1C7.45 16.1 6.97917 15.9042 6.5875 15.5125C6.19583 15.1208 6 14.65 6 14.1V5C6 4.45 6.19583 3.97917 6.5875 3.5875C6.97917 3.19583 7.45 3 8 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V14.1C22 14.65 21.8042 15.1208 21.4125 15.5125C21.0208 15.9042 20.55 16.1 20 16.1H8ZM8 14.1H20V5H8V14.1ZM10 9H18V7H10V9ZM10 12H15V10H10V12Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsOcr);
export default __webpack_public_path__ + "static/media/documents_ocr.e7b9c4386d73e0b6b32b9985d8324773.svg";
export { ForwardRef as ReactComponent };